import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable @cloud-ru/ssr-safe-react/domApi */

import { DEFAULT_BACKEND_HOST, DEFAULT_HEADERS } from './constants';
var DOWNLOADED_FILENAME = 'Расчет_стоимости_CloudRu.xlsx';
var CALCULATOR_RESULT_EXCEL_URL = '/calculator-result/v2/excel';

/**
 *
 * Функция для выгрузки расчета по ценам
 * @function helper
 */
export function getOnDownloadFileClick() {
  var backendHost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BACKEND_HOST;
  return /*#__PURE__*/function () {
    var _onDownloadFileClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(state) {
      var urlBe, res, blob, a, url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            urlBe = backendHost + CALCULATOR_RESULT_EXCEL_URL;
            _context.next = 3;
            return fetch(urlBe, {
              method: 'POST',
              headers: DEFAULT_HEADERS,
              body: JSON.stringify(state)
            });
          case 3:
            res = _context.sent;
            if (res.ok) {
              _context.next = 6;
              break;
            }
            throw new Error("fetcher");
          case 6:
            _context.next = 8;
            return res.blob();
          case 8:
            blob = _context.sent;
            a = document.createElement('a');
            document.body.appendChild(a);
            url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = DOWNLOADED_FILENAME;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function onDownloadFileClick(_x) {
      return _onDownloadFileClick.apply(this, arguments);
    }
    return onDownloadFileClick;
  }();
}